/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MarketRegisterClassicIcon16Light } from './MarketRegisterClassicIcon16Light';
import { MarketRegisterClassicIcon16Regular } from './MarketRegisterClassicIcon16Regular';
import { MarketRegisterClassicIcon16Solid } from './MarketRegisterClassicIcon16Solid';
import { MarketRegisterClassicIcon20Light } from './MarketRegisterClassicIcon20Light';
import { MarketRegisterClassicIcon20Regular } from './MarketRegisterClassicIcon20Regular';
import { MarketRegisterClassicIcon20Solid } from './MarketRegisterClassicIcon20Solid';
import { MarketRegisterClassicIcon24Regular } from './MarketRegisterClassicIcon24Regular';
import { MarketRegisterClassicIcon24Solid } from './MarketRegisterClassicIcon24Solid';
import { MarketRegisterClassicIcon32Regular } from './MarketRegisterClassicIcon32Regular';
import { MarketRegisterClassicIcon64Regular } from './MarketRegisterClassicIcon64Regular';
var sizes = {
    16: {
        light: MarketRegisterClassicIcon16Light,
        regular: MarketRegisterClassicIcon16Regular,
        solid: MarketRegisterClassicIcon16Solid,
    },
    20: {
        light: MarketRegisterClassicIcon20Light,
        regular: MarketRegisterClassicIcon20Regular,
        solid: MarketRegisterClassicIcon20Solid,
    },
    24: {
        regular: MarketRegisterClassicIcon24Regular,
        solid: MarketRegisterClassicIcon24Solid,
    },
    32: {
        regular: MarketRegisterClassicIcon32Regular,
    },
    64: {
        regular: MarketRegisterClassicIcon64Regular,
    },
};
export var MarketRegisterClassicIcon = forwardRef('MarketRegisterClassicIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
